import * as deviceDiagnosticErrors from '../../consts/device/deviceDiagnosticErrors';
import DEVICE_TYPES from '../../enums/device/deviceTypes';
import {updateIotDeviceData} from '../../state/ducks/iotDevice/actions';
import {selectIotDeviceData} from '../../state/selectors/iotDevice';
import {dispatch, getState} from '../../state/store';

export const updateDeviceErrors = (deviceSystemError, isHolder) => {
    const iotDevice = selectIotDeviceData(getState());

    const errors = findErrors(iotDevice?.device?.type, deviceSystemError, isHolder);
    //isHolder in mergeErrors should be true or false only
    const newErrors = mergeErrors(iotDevice?.errors, errors, !!isHolder);

    dispatch(updateIotDeviceData({errors: newErrors}));
};

export const clearDeviceErrors = (isHolder) => {
    const iotDevice = selectIotDeviceData(getState());

    if (!iotDevice) return;

    const newErrors = mergeErrors(iotDevice.errors, undefined, !!isHolder);

    dispatch(updateIotDeviceData({errors: newErrors}));
};

const findErrors = (type, deviceSystemError, isHolder) => {
    if (!deviceSystemError) return;

    //holderErrors and holderWarnings related to device (isHolder = false)
    const {errors, systemErrors, chargerErrors, chargerWarnings, holderErrors, holderWarnings} = deviceSystemError;

    if (isHolder) {
        //only errors related to isHolder = true
        const identifiedErrors = identifyHolderErrors(errors);

        return mapErrors(identifiedErrors, true);
    }

    const allErrors = [];
    let deviceErrors = 0;
    let deviceWarnings = 0;

    switch (type) {
        case DEVICE_TYPES.DEV_TYPE_V24_CHARGER:
        case DEVICE_TYPES.DEV_TYPE_V24P_CHARGER:
        case DEVICE_TYPES.DEV_TYPE_P1V30_CHARGER:
        case DEVICE_TYPES.DEV_TYPE_P1V31_CHARGER:
            deviceErrors = chargerErrors;
            deviceWarnings = chargerWarnings;

            //only for this device types holder related errors inside charger
            const identifiedHolderErrors = identifyErrors(holderErrors, false, true);
            const identifiedHolderWarnings = identifyErrors(holderWarnings, true, true);

            allErrors.push(...identifiedHolderErrors);
            allErrors.push(...identifiedHolderWarnings);
            break;
        case DEVICE_TYPES.DEV_TYPE_P1V30M:
            //for multi same field
            deviceErrors = systemErrors;
            deviceWarnings = systemErrors;
            break;
        case DEVICE_TYPES.DEV_TYPE_P4_M3_G2:
            //error mapping is not defined for P4 devices in deviceDiagnosticErrors file
            deviceErrors = errors;
            deviceWarnings = errors;
            break;
        default:
            break;
    }

    const identifiedErrors = identifyErrors(deviceErrors);
    const identifiedWarnings = identifyErrors(deviceWarnings, true);

    allErrors.push(...identifiedErrors);
    allErrors.push(...identifiedWarnings);

    return mapErrors(allErrors, false);
};

const mapErrors = (errors, isHolder) => {
    if (!errors || !errors.length) return;

    return errors.map((error) => ({
        error_mode: error.mode,
        error_code: error.code,
        l0_code: error.l0Code,
        l1_code: error.l1Code,
        qure_code: error.qureCode,
        is_charger: !error.isHolder,
        isHolderAsset: isHolder,
    }));
};

const mergeErrors = (curErrors, errors, isHolder) => {
    const actualErrors = curErrors?.filter((x) => x.isHolderAsset !== isHolder) || [];

    if (!errors || !errors.length) return actualErrors;

    actualErrors.push(...errors);
    return uniqueErrors(actualErrors);
};

const uniqueErrors = (errors) => {
    return errors.filter(
        (error, index, self) =>
            index ===
            self.findIndex(
                (e) =>
                    e.error_mode === error.error_mode &&
                    e.error_code === error.error_code &&
                    e.l0_code === error.l0_code &&
                    e.l1_code === error.l1_code
            )
    );
};

const identifyHolderErrors = (errors) => {
    const holderErrorMapping = deviceDiagnosticErrors.getHolderErrorMapping();

    return filterErrors(holderErrorMapping, errors);
};

const identifyErrors = (errors, isWarn, holderRelated) => {
    if (!errors) return [];

    const errorMapping = deviceDiagnosticErrors.getErrorMapping(holderRelated);
    const warningMapping = deviceDiagnosticErrors.getWarningMapping(holderRelated);
    const mapping = isWarn ? warningMapping : errorMapping;

    return filterErrors(mapping, errors);
};

const filterErrors = (mapping, errors) => {
    return mapping.filter((x) => isErrorExists(errors, x.shift));
};

const isErrorExists = (errors, shift) => {
    return (errors >> shift) & 1;
};
